import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { SortDataService } from './../../core/services/sortdata';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ICandidat,
  headerColumns,
  statusCandidate,
} from './../../core/models/candidat';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../core/models/messages';
import { CandidatService } from './../../core/services/candidat-service/candidat.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { Country, State } from 'country-state-city';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CallOfferService } from '@core/services/call-offer-service/call-offer.service';
import { translations } from '../../core/models/call-offer';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-candidat-non-abonne',
  templateUrl: './candidat-non-abonne.component.html',
  styleUrls: ['./candidat-non-abonne.component.css'],
})
export class CandidatNonAbonneComponent {
  /* string */
  connectedUser = this.localStorageService.getData('userConnected');
  selectedImage: any;
  listCandidat: any;
  private unsubscribeAll: Subject<void> = new Subject();
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  pagination : boolean =false;
  file: any = '';
  url: string = environment.baseUrl + '/api';
  totalItems!: number;
  itemsPerPage: number = 20;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  mobilities: any[] = [];
  stateList: any = [];
  currentSortDirection: number = 2;
  urlimage: string = environment.baseUrlGalery;
  listCompanys: ICandidat[] = [];
  dataCandidatList: ICandidat[] = [];
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns;
  newHeader!: { checked: boolean; name: string; code: string }[];
  displayedColumns: string[] = [
    'select',
    'ID_user',
    'image_url',
    'first_name',
    'phone_number',
    'updated_at',
    'email',
    'city',
    'years_of_experience',
    'CV',
    'score',
    'status',
    'actions',
  ];
  fileExtention: string = '';
  listNames: string[] = [];
  fileError: string = '';
  countries: any = [];
  fileName: string = '';
  selectedCandidats: any = [];
  skills: any[] = [];
  skillsList: { name_FR: string }[] = [];
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  statut = statusCandidate;
  headerChecked: boolean = false;
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contratRequest = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  postType = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  sortAttr: string = '';
  Statut: { id: string; name: string }[] = [
    { id: '0', name: 'actif' },
    { id: '1', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  dataHeader: any = [];
  availabilituyTypeOptions: { [key: string]: string } = {
    '1': 'Immédiate',
    '2': '1 mois',
    '3': '2 mois',
    '4': '3 mois',
    '5': '4 mois',
    '6': '5 mois',
  };

  contratTypeOptions: { [key: string]: string } = {
    '1': 'Alternance',
    '2': 'Autres type de contrat',
    '3': 'CDD',
    '4': 'CDI',
    '5': 'Freelance',
    '6': 'Portage salarial',
    '7': 'Stage',
  };
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  modalRef?: BsModalRef;
  applyForm: FormGroup = this.createapplyForm();
  id: any;
  fromSelection: boolean = false;
  skillscandidat: any;
  skillscandidatfinal: any = [];
  listskills: any;
  candidats: any[] = [];
  searchForm: FormGroup = this.createSearchForm();
  idoffre = this.activatedRoute.snapshot.params['id'];
  fileNameexcel = 'excel.xlsx';
  selectedCandidates: any[] = [];
  isLoadSpinner: boolean = true;

  allCandidates: any[] = [];
  constructor(
    private router: Router,
    private sortdata: SortDataService,
    private modalService: BsModalService,
    private candidatservice: CandidatService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private callofferservice: CallOfferService,
    private elRef: ElementRef,
    private primengConfig: PrimeNGConfig

  ) {}
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnInit() {
    this.id = this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getListcandidatureexterne();
    this.displayingHeader();
    console.log('liste candidat ', this.getListcandidatureexterne());
    this.getListskills();
    console.log('liste skills ', this.getListskills());
    this.getListElementHeader();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  /* get the list of candidats */
  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    this.currentPage = 1;
    // let sort={sort:this.currentSortDirection,sortAttribute:item}
    // console.log("sort",sort)
    // if(this.searchForm.value!='') this.listCandidat = this.sortdata.sortArray(this.listCandidat, item, this.currentSortDirection)
    // else
    if (this.searchForm.dirty)
      this.listCandidat = this.sortdata.sortArray(
        this.listCandidat,
        item,
        this.currentSortDirection
      );
    else this.getListcandidatureexterne();
  }
  translateCountryName(name: string): string {
 
    return translations[name] || name;
  }
  getListElementHeader() {
    // if(!this.typeintervenant){
    this.callofferservice
      .getHeaderElementscandidatcf(20)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
              console.log("listnames",this.listNames)
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
    // }
    // else
    // {
    //   this.candidatservice
    //   .listPageActorIntervenant()
    //   .pipe(takeUntil(this.unsubscribeAll))
    //   .subscribe({
    //     next: (res) => {
    //       this.dataHeader = res.data;
    //       for (const iterator of this.dataHeader) {
    //         if (
    //           (iterator.checked == 'oui' && !iterator.checked_user) ||
    //           (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
    //           (iterator.checked == 'oui' && iterator.checked_user == 'oui')
    //         )
    //           this.listNames.push(iterator.name);
    //       }
    //       this.dataHeader.map((el: any) => {
    //         if (
    //           (el.checked == 'oui' && !el.checked_user) ||
    //           (el.checked_user == 'oui' &&
    //             (el.checked == 'non' || el.checked == 'oui'))
    //         ) {
    //           return (el.checkAdmin = true);
    //         } else {
    //           return (el.checkAdmin = false);
    //         }
    //       });
    //     },
    //     error: () => { },
    //   });
    // }
  }
  getListcandidatureexterne() {
    this.spinner.show();

    let dataPyload =
      this.sortAttr == ''
        ? { id: this.id, per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{
              id: this.id,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.candidatservice.getListcandidatureexterne(dataPyload).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listCandidat = response.data.data
          // .slice(0, this.endIndex);
          console.log(' this.listcandidats', this.listCandidat);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list candidatures', this.listCandidat);
        }
      },
      error: (error) => {
        console.error('Error fetching salaries: ', error);
      },
    });
  }

  /* ************************* navigation company ********************* */
  profilCandidatNavigation(id: any) {
    this.router.navigate(['/profil-candidats', { id: id }]);
  }
  profilCallNavigation(id: any) {
    this.router.navigate(['/detail-offre', { id: id }]);
  }
  profilCompanyNavigation(id: any) {
    this.router.navigate([
      '/entreprises/details-entreprise',
      { id: id },
    ]);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  changeSelectCandidatss(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.headerChecked = event.target.checked;
      this.selectedCandidats = event.target.checked ? this.listCandidat : [];
    } else {
      if (candidat) {
        if (event.target.checked) {
          this.selectedCandidats.push(candidat);
        } else {
          let indexId = this.selectedCandidats.findIndex(
            (el: { id: number }) => {
              return el.id == candidat.id;
            }
          );
          if (indexId !== -1) {
            this.selectedCandidats.splice(indexId, 1);
          }
        }
      }
    }
  }
  /* get candidats selected */

  changeSelectCandidats(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.fromSelection = event.target.checked ? true : false;
      this.headerChecked = event.target.checked;
      this.selectedCandidats = event.target.checked
        ? [...this.listCandidat]
        : [];

      this.selectedCandidats.forEach((el: ICandidat) => {
        el.checked = event.target.checked;
      });
    } else {
      if (candidat) {
        if (event.target.checked) {
          this.selectedCandidats.push(candidat);
          candidat.checked = true;
        } else {
          let indexId = this.selectedCandidats.findIndex(
            (el: { id: number }) => {
              return el.id == candidat.id;
            }
          );
          if (indexId !== -1) {
            this.selectedCandidats.splice(indexId, 1);
            candidat.checked = false;
          }
        }
      }
    }
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}

  /* ************************************ Search ***************************** */
  /* create search form */
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      company_name: ['', data?.company_name],
      candidate_name: ['', data?.candidate_name],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      contract_type: [[], data?.contract_type],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      city: [[], data?.city],
      country: [[], data?.country],
      start_date: ['', data && data.start_date],
      end_date: ['', data && data.end_date],
      profil_étrangers: [null, data && data.profil_étrangers],
      passeport_talent: [null, data && data.passeport_talent],
      state: ['', data && data.state],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      client_id: this.id,
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  /* search */
  searchCandidat() {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      name: this.searchForm.value.name,
      candidate_name: this.searchForm.value.candidate_name,
      company_name: this.searchForm.value.company_name,
      years_of_experience: this.searchForm.value.years_of_experience,
      experience_range: this.searchForm.value.experience_range,
      contract_type: this.searchForm.value.contract_type,
      desired_salary: this.searchForm.value.desired_salary
        ? this.searchForm.value.desired_salary.toString()
        : '',
      desired_salary_range: this.searchForm.value.desired_salary_range
        ? this.searchForm.value.desired_salary_range.toString()
        : '',
      tjm: this.searchForm.value.tjm
        ? this.searchForm.value.tjm.toString()
        : '',
      tjm_range: this.searchForm.value.tjm_range
        ? this.searchForm.value.tjm_range.toString()
        : '',
      post_type: this.searchForm.value.post_type,
      skillsOr: this.searchForm.value.skillsOr,
      skillsAnd: this.searchForm.value.skillsAnd,
      availability: this.searchForm.value.availability,
      country: valueForm.country ? valueForm.country : '',
      city: valueForm.city ? valueForm.city : '',
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      state: valueForm.state,
      page: this.currentPage,
      per_page: this.itemsPerPage,
      search: this.transformSearch(this.searchForm.value?.search),
      client_id: this.id,
    };
    console.log('data', data);
    this.spinner.show();
    this.candidatservice.searchCandidatureexterne(this.id, data).subscribe({
      next: (resSearch) => {
        console.log('response search', resSearch);
        this.listCandidat = resSearch;
        console.log('status', resSearch.status);
        if (resSearch.status == 200) {
          this.listCandidat = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastr.error(serverError);
        this.spinner.hide();
      },
    });
  }

  ////////////////////////////////////////date de creation pour le liste ///////////////////////////////
  formatDate(dateString: string | null): string {
    if (!dateString) {
      return ''; // Gérer le cas où la date est null ou undefined
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || ''; // Gérer le cas où la transformation échoue
  }

  /* deafault displaying table header */
  displayingHeader() {
    for (const iterator of this.headerColumns) {
      if (!iterator.checked) {
        let index = this.displayedColumns.findIndex((element) => {
          return iterator.code == element;
        });
        if (index > -1) {
          this.displayedColumns.splice(index, 1);
        }
      }
    }
    this.newHeader = this.headerColumns.filter((el) => {
      return el.checked;
    });
  }

  /* change country select and delete the string Governorate from state name*/
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        console.log('difference1 : ', difference1.length);
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            console.log('new_array is ', item.name);
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          } else {
            console.log('String not found in array.', item.name);
          }
        }
      }
    });

    console.log('stateListAfter1 ', stateListAfter1);

    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }

  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  /* change the header elements from menu checkbox */
  changeHeaderCheckbox(element: {
    checked: boolean;
    name: string;
    code: string;
  }) {
    this.headerColumns.map((el) => {
      if (el.code === element.code) {
        el.checked = !el.checked;
        if (el.checked) {
          this.displayedColumns = this.headerColumns.map((obj) => obj.code);
          this.displayedColumns.push('actions', 'more');
        }
      }
    });
    this.displayingHeader();
  }

  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (type == 'single' && candidat) {
      if (candidat.cv || candidat.file_test) {
        if (typeFile && typeFile != '')
          candidat.file_test = candidat.file_test.split('/')[1];
        const fileUrl = !typeFile
          ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
          : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
        this.showGlobalSpinner();
        this.candidatservice.downloadPDF(fileUrl).subscribe(
          (data) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = !typeFile
              ? `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_CV.${candidat!.cv.split('.').pop()}`
              : `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_QCM.${candidat!.file_test.split('.').pop()}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.hideGlobalSpinner();
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
      } else {
        this.toastr.info(EmptyCV);
      }
    } else if (this.selectedCandidats.length) {
      if (this.selectedCandidats.length == 1 && !this.selectedCandidats[0].cv) {
        this.toastr.info(EmptyCV);
      } else this.downloadPdfFiles(typeFile);
    } else {
      this.toastr.info(obligationSelect);
    }
  }
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  //////////////////////////////////////////////////////////////////////////////////////
  downloadreponse(candidat: any) {
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${candidat.file_test}`;
    this.candidatservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${candidat.ID_user}_${candidat.first_name}_${
        candidat.last_name
      }_CV.${candidat.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
  }

  /////////////////////////////////////////////////////////////////////////////////////
  // changeSelection(event: any, data: any) {
  //   data.checked = event.target.checked;
  // }
  // changeSelection(event: any, data: any, i: number) {
  //   this.listNames = [];
  //   data.checkAdmin = event.target.checked;
  //   for (const iterator of this.dataHeader) {
  //     if (iterator.checkAdmin) this.listNames.push(iterator.name);
  //   }
  //   this.changeSelectionHeadrElements(data);
  // }
  // changeSelectionHeadrElements(data: any) {

  //   let payload = {
  //     sub_page_id: data?.id,
  //   };
  //   this.callofferservice
  //     .changeDelectedElementHeadercandidatcf(payload)
  //     .pipe(takeUntil(this.unsubscribeAll))
  //     .subscribe({
  //       next: (res) => {},
  //       error: () => {},
  //     });
   
  // }

  ///////////////////////////////////////////////////////////////////////////////////////////////////
  howGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  getFormattedDate(): string {
    const dateValue = this.searchForm.get('date_last_update')!.value;
    return moment(dateValue).format('DD/MM/YYYY');
  }

  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchCandidat();
    this.getListcandidatureexterne();
  }

  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCandidat();
      } else  if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListcandidatureexterne();
      }
    }
  }

  // sortData(item:string){
  //   this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
  //   this.sortAttr=item
  //   if(this.searchForm.value!='') this.listCandidat = this.sortdata.sortArray(this.listCandidat, this.sortAttr, this.currentSortDirection)
  //   else this.getListcandidatureexterne()
  // }

  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // getskills salarie

  getListskills() {
    this.candidatservice.getSkills().subscribe({
      next: (response) => {
        console.log('list skills', response);
        if (response.data) {
          this.listskills = response.data;

          console.log('list skills', this.listskills);
        }
      },
      error: (error) => {
        console.error('Error fetching skills: ', error);
      },
    });
  }

  getCandidats(id: number) {
    this.candidatservice
      .getListcandidatsanspagination(id)
      .subscribe((response) => {
        this.listCandidat = response.data; // Assurez-vous d'ajuster cela en fonction de la structure de votre réponse
      });
  }

  createapplyForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [data ? data.availibility_date : ''],
    });
  }

  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    console.log('Identifianddddt:', data);
    this.id = data?.id;

    if (data) {
      this.id = data?.id;
      this.applyForm = this.createapplyForm(data);
      this.applyForm
        .get('commercial_argument')
        ?.setValue(data.commercial_argument);
      this.applyForm.get('availibility_date')?.setValue(data.availibility_date);
      this.applyForm.get('tjm_vente')?.setValue(data.tjm_vente);
      console.log('Identifiant:', this.id);
    }
  }

  closeModal() {
    this.modalRef!.hide();
    this.applyForm.reset();
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
